

















import { Vue, Component } from "vue-property-decorator";
import CPage from "@/components/form/CustomPage/CPage.vue";
import ConditionForm from "@/components/condition/ConditionForm.vue";
import { agentApi } from "@/getinfo-api";
import { Condition as ICondition } from "@/api-v2/agent/models/condition";

@Component({
  components: { ConditionForm, CPage }
})
export default class ConditionCreate extends Vue {
  isLoading: boolean = false;

  get breadcrumbs() {
    return [
      {
        to: { name: "conditionList" },
        label: this.$tc(this.$translate.ConditionList)
      },
      {
        label: this.$tc(this.$translate.Create)
      }
    ];
  }

  async saveHandler(condition: ICondition) {
    try {
      this.isLoading = true;
      const { data } = await agentApi.Condition.createCondition(condition);
      await this.$router.push({
        name: "conditionView",
        params: { id: data.id! }
      });
    } catch (e) {
      await this.$store.dispatch("errorException", {
        vm: this,
        error: e.response
      });
    } finally {
      this.isLoading = false;
    }
  }

  cancelHandler() {
    this.$router.push({ name: "conditionList" });
  }
}
